module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "150px 0"
    }
  }, [_c('div', {
    staticClass: "text-center",
    staticStyle: {
      "height": "40px",
      "line-height": "40px"
    }
  }, [_c('span', {
    staticClass: "fa fa-spinner rotate",
    staticStyle: {
      "font-size": "40px"
    }
  }), _vm._v(" "), _c('span', [_vm._v("数据加载中...")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-123dcfd5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/loading.vue
// module id = 464
// module chunks = 1